<template>
  <VacancyContainer
    :id="vacancyId"
    v-slot="{ company, vacancy }"
    @ready="handleVacancyContainerReady"
  >
    <AppPreloader v-if="!fetched && !company.isFetching" />
    <template v-else>
      <div class="interview-welcome">
        <VRow justify="center">
          <VCol v-if="!$route.meta.iframe" cols="12" md="3" lg="3" xl="2">
            <CompanySmallCard :company="company" />
          </VCol>
          <VCol cols="12" md="8">
            <VCard elevation="1" class="pa-3 pa-md-7 px-md-12 mb-5">
              <div v-if="candidate">
                <div class="d-flex justify-space-between mb-2">
                  <span
                    class="font-weight-medium mr-4 order-0"
                    :class="$vuetify.breakpoint.mdAndUp ? 'headline' : 'title'"
                  >
                    {{ $t('hello')
                    }}<span v-show="!isWrongCandidateName">, {{ candidate.firstName }}</span>!
                  </span>
                  <VMenu
                    v-model="confirmEmailDialog"
                    left
                    offset-y
                    origin="top right"
                    :close-on-content-click="false"
                    z-index="500"
                    min-width="320"
                  >
                    <template v-slot:activator="{ on }">
                      <span
                        v-show="!isWrongCandidateName"
                        class="
                        order-3
                        order-md-1
                        pseudo-link-text
                        blue--text
                        text-no-wrap
                        interview-welcome__wrong-name-link
                        d-flex
                        flex-column
                        justify-center
                        body-2
                        pb-4
                        pb-md-0
                      "
                        v-on="on"
                      >
                        {{ $t('notMe') }} {{ candidate.firstName }}
                      </span>
                    </template>
                    <VCard tile class="pa-5" width="320">
                      <VBtn
                        fab
                        icon
                        right
                        top
                        absolute
                        class="mt-5 mr-n6"
                        @click="confirmEmailDialog = false"
                      >
                        <VIcon width="11" dense small>
                          {{ mdiClose }}
                        </VIcon>
                      </VBtn>
                      <div v-if="!changeNameLaterDialog">
                        <div>
                          <a :href="`mailto:${candidate.email}`" class="text-decoration-none">
                            {{ candidate.email }}
                          </a>
                          <br>
                          {{ $t('emailConfirm') }}
                        </div>
                        <div class="d-flex pt-4">
                          <VBtn
                            color="primary"
                            dark
                            class="mr-2 px-6"
                            @click="handleConfirmEmailDialogYes"
                          >
                            {{ $t('yes') }}
                          </VBtn>
                          <VBtn
                            color="grey darken-2"
                            dark
                            class="px-6"
                            @click="handleConfirmEmailDialogNo"
                          >
                            {{ $t('no') }}
                          </VBtn>
                        </div>
                      </div>
                      <div v-else>
                        <span>
                          {{ $t('editInfoTip') }}
                        </span>
                        <div class="d-flex pt-4">
                          <VBtn
                            color="primary"
                            dark
                            class="mr-2 px-6"
                            @click="handleChangeNameLaterDialogOk"
                          >
                            {{ $t('understood') }}
                          </VBtn>
                        </div>
                      </div>
                    </VCard>
                  </VMenu>
                </div>
                <div class="d-flex justify-space-between mb-2">
                  <div class="mb-3 mb-md-6 mt-4 body-2 font-weight-regular w-100 order-2">
                    <!-- eslint-disable-next-line -->
                    {{ $t('company') }} {{ company.name }} {{ $t('invitationTip') }} "{{
                      vacancy.title
                    }}"
                  </div>
                </div>
              </div>
              <div v-else />
              <VSheet v-if="canStartVideo" max-width="600" class="mx-auto mb-5 mb-md-10">
                <VResponsive :aspect-ratio="16 / 9" max-width="1000" class="rounded-corners">
                  <InterviewHelloPlayer
                    v-if="vacancy.script && vacancy.script.interviewer && canStartVideo"
                    :interviewer="vacancy.script.interviewer"
                  />
                  <div v-else />
                </VResponsive>
                <AppWithLoading v-slot:default="{ loader }">
                  <div
                    class="d-flex mt-4 flex-wrap flex-lg-nowrap align-center
                  flex-lg-row flex-column justify-space-between"
                  >
                    <VBtn
                      color="primary"
                      dark
                      :width="$vuetify.breakpoint.smAndDown ? '100%' : 'auto'"
                      class="toInterview"
                      @click="loader(() => resetInterviewStep())"
                    >
                      {{ $t('toInterview') }}
                    </VBtn>
                    <ClientOnly>
                      <span v-if="candidate">
                        <span
                          class="
                        pseudo-link-text
                        blue--text
                        text-no-wrap
                        d-flex
                        flex-column
                        justify-center
                        mr-lg-4
                        pt-6
                        pt-lg-0
                        body-2
                      "
                          @click="refuseDialog = true"
                        >
                          {{ $t('cancel') }}
                        </span>
                      </span>
                    </ClientOnly>
                  </div>
                </AppWithLoading>
              </VSheet>
              <h1 class="mb-1 pt-8 title">
                {{ vacancy.title }}
              </h1>
              <div class="font-weight-regular body-2">
                <span>
                  <VacancySalary :salary="vacancy.salary" />
                </span>
                <br>
                <span v-if="vacancy.address">
                  {{ vacancy.address.city }}
                </span>
                <span v-else />
              </div>
              <VacancyCard :vacancy="vacancy" class="mt-6 body-2" />
            </VCard>
          </VCol>
        </VRow>
      </div>
      <div v-if="candidate">
        <VDialog v-model="refuseDialog" persistent max-width="760">
          <VCard class="pa-8 py-12" color="#F5FAFE" max-width="760">
            <VBtn class="refuse-close-btn" fab icon absolute @click="refuseDialog = false">
              <VIcon width="11" dense small>
                {{ mdiClose }}
              </VIcon>
            </VBtn>
            <h1 class="title font-regular text-center mb-6">
              {{ $t('reason') }}
            </h1>
            <InterviewRefuseForm
              :candidate-id="candidate.id"
              class="my-3 mb-2"
              @refused="handleRefuse"
              @cancel="refuseDialog = false"
            />
          </VCard>
        </VDialog>
      </div>
      <div v-else />
      <template />
    </template>
  </VacancyContainer>
</template>

<script>
import { ref } from '@vue/composition-api';
import { mdiClose } from '@mdi/js';
import ClientOnly from 'vue-client-only';
import { canRecordInterview } from '@huntica/huntica-interview-module/src/helpers';
import useLocale from '@/compositions/useLocale';
import AppPreloader from '@/components/AppPreloader.vue';
import { mapState } from 'vuex';
import useCompany from '@/compositions/useCompany';
import httpClient from '@/api';
import VacancyContainer from '../components/Vacancy/VacancyContainer.vue';
import VacancyCard from '../components/Vacancy/VacancyCard.vue';
import VacancySalary from '../components/Vacancy/VacancySalary.vue';
import CompanySmallCard from '../components/Company/CompanySmallCard.vue';
import InterviewRefuseForm from '../forms/InterviewRefuseForm.vue';
import InterviewHelloPlayer from '../components/Interview/InterviewHelloPlayer.vue';
import { candidateStatuses } from '../enums';
import { isIOS, safeGet } from '../functions';
import AppWithLoading from '../components/AppWithLoading.vue';
import useTestInterview from '../compositions/useTestInterview';

export default {
  name: 'VacancyReply',
  components: {
    AppWithLoading,
    AppPreloader,
    ClientOnly,
    VacancyContainer,
    VacancyCard,
    VacancySalary,
    CompanySmallCard,
    InterviewRefuseForm,
    InterviewHelloPlayer,
  },
  metaInfo() {
    return {
      title: this.pageTitle,
    };
  },
  props: {
    vacancyId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      pageTitle: null,
      isWrongCandidateName: false,
      confirmEmailDialog: false,
      changeNameLaterDialog: false,
      refuseDialog: false,
      mdiClose,
      canRecordInterview: process.browser && canRecordInterview(),
      isIOS: isIOS(),
    };
  },
  setup() {
    const { setLocaleFromQuery } = useLocale();
    const { isTest } = useTestInterview();
    const { fetchCompanyById } = useCompany();

    return {
      setLocaleFromQuery,
      pageTitle: ref(null),
      isWrongCandidateName: ref(false),
      confirmEmailDialog: ref(false),
      changeNameLaterDialog: ref(false),
      refuseDialog: ref(false),
      mdiClose,
      canRecordInterview: process.browser && canRecordInterview(),
      isIOS: isIOS(),
      isTest,
      fetched: false,
      fetchCompanyById,
    };
  },
  computed: {
    ...mapState('company', ['company']),
    candidate() {
      const candidate = safeGet(this.$store.state.candidate, ['data', 'candidate']);
      if (candidate?.vacancyId !== this.vacancyId) {
        return null;
      }
      if (!candidate) {
        return null;
      }
      return candidate;
    },
    candidateVacancy() {
      if (!this.candidate) {
        return null;
      }
      return safeGet(this.$store.state.candidate, ['data', 'vacancy']);
    },
    canStartVideo() {
      return this.$route.name === 'vacancyReply' || this.$route.name === 'iframeVacancyReply';
    },
  },
  async created() {
    if (this.$route.meta.iframe) {
      this.calculateHeight();
    }

    await this.fetch();

    if (this.company?.data?.companyTemplateSettings
      && this.$route?.query?.preview !== 'true') {
      if (this.isIOS && !this.canRecordInterview) {
        this.$router.push({
          name: 'interviewIframe',
          params: {
            companyId: this.candidateVacancy.companyId,
            vacancyId: this.candidateVacancy.id,
            isIosDevice: true,
          },
        });
      }
    } else {
      this.fetched = true;
    }

    if (this.company?.data?.companyTemplateSettings
      && this.$route?.query?.preview !== 'true'
      && !this.$route.meta.iframe
      && !this.isTest) {
      window.location.href = `${process.env.VUE_APP_CAREER_PORTAL_URL}/${this.company.data.id}/vacancies/${this.vacancyId}/reply/${this.$route.params.hashId}`;
    } else {
      this.fetched = true;
    }

    if (!this.candidate) {
      return null;
    }

    if (this.candidate.status === candidateStatuses.INTERVIEWED
      && this.candidate.interview) {
      return this.$router.push({
        name: this.$route.meta.iframe ? 'iframeInterviewResult' : 'interviewResult',
        params: {
          companyId: this.candidateVacancy.companyId,
          vacancyId: this.candidateVacancy.id,
        },
      });
    }

    if (this.candidate.interview) {
      return this.$router.push({
        name: this.$route.meta.iframe ? 'iframeInterviewContinue' : 'interviewContinue',
        params: {
          companyId: this.candidateVacancy.companyId,
          vacancyId: this.candidateVacancy.id,
        },
      });
    }

    return null;
  },
  methods: {
    async fetch() {
      if (this.$route.params.hashId) {
        const token = await this.$store.dispatch('candidate/loginByHashId', {
          hashId: this.$route.params.hashId,
          vacancyId: this.vacancyId,
        });
        const candidate = await httpClient.get('candidates');
        await this.$store.dispatch('company/fetchCompany', this.$route.params.companyId);
        await this.$store.dispatch('candidate/fetchData', {
          vacancyId: candidate.data.data.vacancyId,
          token,
        });
        return;
      }

      await Promise.all([
        await this.$store.dispatch('company/fetchCompany', this.$route.params.companyId),
      ]);
    },
    handleConfirmEmailDialogYes() {
      this.isWrongCandidateName = true;
      this.changeNameLaterDialog = true;
    },
    handleConfirmEmailDialogNo() {
      this.$store.commit('candidate/logout');
      this.confirmEmailDialog = false;
    },
    handleChangeNameLaterDialogOk() {
      this.confirmEmailDialog = false;
    },
    handleRefuse() {
      this.refuseDialog = false;
      this.$store.commit('candidate/logout');
    },
    handleVacancyContainerReady({ vacancy }) {
      this.pageTitle = `${this.$t('vacancy')} ${vacancy.title}`;
      this.setLocaleFromQuery(this.$route);
    },
    async resetInterviewStep() {
      localStorage.removeItem('interviewStep');
      if (await this.isTest(this.vacancyId)) {
        await this.$router.push({
          name: this.$route.meta.iframe ? 'iframe_interview_test' : 'interview_test',
          params: { vacancyId: this.vacancyId, companyId: this.company.data.id },
        });
      } else {
        await this.$router.push({
          name: this.$route.meta.iframe ? 'interviewIframe' : 'interview',
          params: { vacancyId: this.vacancyId, companyId: this.company.data.id },
        });
      }
    },
    calculateHeight() {
      this.$nextTick(() => {
        setTimeout(() => {
          let height = document.documentElement.scrollHeight;
          if (document.documentElement.offsetHeight > height) {
            height = document.documentElement.offsetHeight;
          }
          // eslint-disable-next-line no-restricted-globals
          parent.postMessage({ height }, '*');
        }, 1000);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.refuse-close-btn {
  top: 0;
  right: 0;
}
.interview-welcome {
  &__wrong-name-link {
    position: relative;
    top: -4px;
  }
}

.toInterview:only-child {
  margin: 0 auto;
}

.w-100 {
  width: 100%;
}

::v-deep {
  .v-text-field--outlined fieldset {
    border-color: #e0e0e0 !important;
  }
}
</style>

<i18n locale="en" lang="yaml">
  hello: Hello
  notMe: I am not
  emailConfirm: Is this your e-mail address?
  yes: Yes
  no: No
  editInfoTip: You can correct your personal information during the interview
  understood: Ok
  company: Company
  invitationTip: invites you to take an online interview for the position
  toInterview: Record an online interview
  cancel: I do not plan to take this interview
  prefix: ''
  reason: Tell us why you do not want to take the online interview
  vacancy: Job
  back: Back
</i18n>

<i18n locale="ru" lang="yaml">
  hello: Здравствуйте
  notMe: Я не
  emailConfirm: Это ваш электронный адрес?
  yes: Да
  no: Нет
  editInfoTip: Информацию о себе вы сможете исправить в процессе прохождения интервью
  understood: Понятно
  company: Компания
  invitationTip: приглашает вас пройти виртуальное собеседование на позицию
  toInterview: Пройти онлайн-собеседование
  cancel: Не планирую проходить собеседование
  prefix: з/п
  reason: Расскажите о причине отказа
  vacancy: Вакансия
  back: Назад
</i18n>
